import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Feedback from './pages/Feedback';
import Calculator from './pages/Calculator';
import NoMatch from './pages/NoMatch';
import KitchenInstallation from './pages/KitchenInstallation';
import FurnitureInstallation from './pages/FurnitureInstallation';
import BBQInstallation from './pages/BBQInstallation';

import registerServiceWorker from './registerServiceWorker';
import './styles/App.css';


// import react router deps
import { Router, Route, IndexRoute } from 'react-router';
import { Provider } from 'react-redux';
import store, { history } from './store';
import * as firebase from 'firebase';

const config = {
    apiKey: "AIzaSyAZyuk7xunqRDX1cJVYBuJ6aIUqtcyLjr0",
    authDomain: "cna-website-18d50.firebaseapp.com",
    databaseURL: "https://cna-website-18d50.firebaseio.com",
    projectId: "cna-website-18d50",
    storageBucket: "cna-website-18d50.appspot.com",
    messagingSenderId: "940721448464"
};
firebase.initializeApp(config);
const $ = require('jquery');
window.jQuery = $;
require('bootstrap-sass/assets/javascripts/bootstrap');

const closeHeader = function () {
    if (window.innerWidth < 768) {
        $('.navbar-toggle[aria-expanded="true"]').click()
    }
};
const reload = () => { window.location.reload(); }

const router = (
  <Provider store={store}>
    <Router history={history}>
        <Route path="/" component={App}>
            <IndexRoute component={Home} onLeave={closeHeader}/>
            <Route path="/about" component={About} onLeave={closeHeader}/>
            <Route path="/kitchen-installation-sydney" component={KitchenInstallation} onLeave={closeHeader}/>
            <Route path="/furniture-installation-sydney" component={FurnitureInstallation} onLeave={closeHeader}/>
            <Route path="/barbeque-installation-sydney" component={BBQInstallation} onLeave={closeHeader}/>
            <Route path="/gallery" component={Gallery} onLeave={closeHeader}>
                <Route path="/gallery/:tag" component={Gallery} onLeave={closeHeader}/>
            </Route>
            <Route path="/contact-us" component={Contact} onLeave={closeHeader}>
                <Route path="/contact-us/:service" component={Contact} onLeave={closeHeader}/>
            </Route>
            <Route path="/privacy-policy" component={PrivacyPolicy} onLeave={closeHeader}/>
            <Route path="/calculator" component={Calculator} onLeave={closeHeader}/>
            <Route path="/feedback" component={Feedback} onLeave={closeHeader}/>
        </Route>
        <Route path="*" component={NoMatch} onLeave={closeHeader}/>
        <Route path="/googlebb16baff2034f17e.html" onEnter={reload}/>
    </Router>
  </Provider>
);

ReactDOM.render(router, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js